import React from 'react';

import styles from './HeaderN.scss';
import classNames from 'classnames/bind';
import {Link} from 'react-router-dom';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBars } from '@fortawesome/free-solid-svg-icons';
// import {Link} from 'react-router-dom';

const cx = classNames.bind(styles);

const Header = () => {
  // const {pathname} = window.location;

  return (
    <header>
      <div className={cx('container')}>
        <Link to="/"><div className={cx('logo')}>이터인포</div></Link>
        <nav className={cx('nav')}>
          <Link to="/item">아이템검색</Link>
          <Link to="/plusup">플러스업</Link>
        </nav>
      </div>
    </header>

    // <header className={cx('eterheader')}> 
    //   <div className={cx('top-menu')}>
    //     <div className={cx('logo')}>
    //       <div className={cx('title')}>
    //         <Link to="/">
    //           <span className={cx('main-title')}>이터인포</span>
    //           <span className={cx('sub-title')}>이터널시티의 모든정보</span>
    //         </Link>

    //         <Link to="/item">
    //           <span className={cx('menu-title')}>아이템검색</span>
    //         </Link>
    //         <Link to="/plusup">
    //           <span className={cx('menu-title')}>플러스업</span>
    //         </Link>
    //         {/* <Link to="/haebang">
    //           <span className={cx('menu-title')}>해방표</span>
    //         </Link> */}
    //       </div>
    //     </div>
    //     {/* <div className={cx('menu')}>
    //       <FontAwesomeIcon icon={faBars} />
    //     </div> */}
    //   </div>
    //   <div className={cx('bottom-menu')}>
    //     <ul>
    //       <li className={cx('menu-item')}><Link to="/item">아이템검색</Link></li>
    //       <li className={cx('menu-item')}><Link to="/plusup">플러스업</Link></li>
    //       {/* <li className={cx('menu-item')}>용병검색</li> */}
    //       {/* <li className={cx('menu-item')}>스킬검색</li> */}
    //       {/* <li className={cx('menu-item')}>몬스터검색</li>
    //       <li className={cx('menu-item')}>게임가이드</li> */}
    //       {/* <li className={cx('menu-item')}><Link to="/custom">시뮬레이션</Link></li> */}
    //       {/* <li className={cx('menu-item')}>커뮤니티</li> */}
    //     </ul>
    //   </div>
    // </header>
  );
};

export default Header;